import { render } from "./Menu.vue?vue&type=template&id=4de3e821&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=4de3e821&lang=css"

import exportComponent from "F:\\GitLab\\Production\\Techbodia\\75aG4svy\\0\\frontend\\techbodia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__